import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";
import {GroupModel} from "../models/group.model";

export class GroupsRequestsService {

  /* @ngInject */
  constructor(private groupsAPI: BringozApi, private $groups) {
  }

  // ******************************
  //        Public methods
  // ******************************

  createGroup(group: GroupModel) {
    const api = this.groupsAPI.actions.createGroup;
    return this.$$call(api, {}, group, {});
  }

  editGroup(group: GroupModel) {
    const api = this.groupsAPI.actions.editGroup;
    return this.$$call(api, {}, group, {groupId: group.id});
  }

  getTotalGroups() {
    const api = this.groupsAPI.actions.getTotalGroups;
    return this.$$call(api, {}, {}, {});
  }

  deleteGroup(groupId: string) {
    const api = this.groupsAPI.actions.deleteGroup;
    return this.$$call(api, {}, {}, {groupId: groupId});
  }

  addBranchesToGroup(groupId: string, branchQuery?: string, branchIds?: string[], excludedBranchIds?: string[], tags?: string[]) {
    const api = this.groupsAPI.actions.addBranchesToGroup;
    return this.$$call(api, {
      branchQuery: branchQuery,
      excludedBranchId: excludedBranchIds,
      branchId: branchIds,
      tag: tags
    }, {}, {groupId: groupId});
  }

  // ******************************
  //        Private methods
  // ******************************


  $$call(_apiCall, _params, _data, _options) {
    return this.$groups().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.groups')
  .service('groupsRequestsService', GroupsRequestsService);
